export function slideIn(element, immediate = true) {
  return function slideInAnimation({ timeline, label }) {
    timeline
      .set(element, { autoAlpha: 1 }, `${label}+=0.001`)
      .fromTo(
        element,
        1,
        { y: window.innerHeight, immediateRender: immediate },
        { y: 0 },
        label,
      );
  };
}

export function slideOut(element) {
  return function slideOutAnimation({ timeline, label }) {
    timeline
      .to(element, 1, { y: -window.innerHeight }, label)
      .set(element, { autoAlpha: 0 }, `${label}+=1`);
  };
}

export function show(element) {
  return function showAnimation({ timeline, label }) {
    timeline.to(element, 1, { autoAlpha: 1 }, label);
  };
}

export function hide(element) {
  return function hideAnimation({ timeline, label }) {
    timeline.to(element, 1, { autoAlpha: 0 }, label);
  };
}



// WEBPACK FOOTER //
// ./src/scripts/modules/animations.js